import {
    ChartLegend,
    ChartLegendContainer,
    ChartLegendDesc,
    InnerCircle,
    InnerText,
    StatsChart,
    StatsChartWrapper
} from "./StatisticsChart.styles";
import React from "react";
import {ColoredText} from "../../../parts/Navbar/Navbar.styles";

const StatisticsChart = ({data}) => {
    return (
        <StatsChartWrapper>
            <ChartLegendContainer>
                <ChartLegend>
                    {'Zwycięstwa'}
                </ChartLegend>
                <ChartLegendDesc>
                    {'Do zwycięstw zaliczają się wszystkie spotkania z wynikiem: '}
                    <ColoredText color={'#9ec400'}>{'Zwycięstwo'}</ColoredText>{', '}
                    <ColoredText color={'grey'}>{'Remis'}</ColoredText>{'.'}
                </ChartLegendDesc>
            </ChartLegendContainer>
            <StatsChart ratio={data}>
                <InnerCircle>
                    <InnerText>{data * 100 + ' %'}</InnerText>
                </InnerCircle>
            </StatsChart>
            <ChartLegendContainer>
                <ChartLegend>
                    {'Porażki'}
                </ChartLegend>
                <ChartLegendDesc>
                    {'Do porażek zaliczają się wszystkie spotkania z wynikiem: '}
                    <ColoredText color={'#bf0010'}>{'Przegrana'}</ColoredText>{'.'}
                </ChartLegendDesc>
            </ChartLegendContainer>
        </StatsChartWrapper>
    );
};

export default StatisticsChart;
